import { axiosInstance, baseUrl } from "./auth";
import { useQuery } from 'react-query'
import { ApiStatus } from "../constants";



export const  CATEGORY_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/listCategory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  CATEGORY_ADD = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/category`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  CATEGORY_UPDATE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/updateCategory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  CATEGORY_DELETE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/deleteCategory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}


export const  CATEGORY_STATUS_CHANGE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/toggleStatusCategory`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}









